import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Padrão Escola',
  path: '/merenda/padraoescola',
  name: 'padraoescola',
  component: () => import('@/views/merenda/padraoescola/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.PADRAOESCOLANOVO_MENU_1900200399],
  },
  goesToMenu: true,
 },
]

